import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/copy`;

export const ROUTE: RouteDefinition = `${baseRoute}/copy`;

export const URL = (): RouteDefinition => `${baseRoute}/copy`;
